import React from "react";

function Certificates() {
  return (
    <div id="certificates">
      <h1 className="sectionHeader">
        <span>Certificates</span>
      </h1>
      <div className="certificates">
        <div className="certificate">
          <h6>
            <a
              rel="noopener noreferrer"
              className="certificateLink"
              target="_blank"
              href="https://drive.google.com/file/d/1iwvJRCpItGz8nlDiIk8SORyH_3uZsAVZ/view?usp=sharing"
            >
              Scrum Foundation Professional Certificate (SFPC)
            </a>
          </h6>
          <p className="date">Completed in 07/23/20</p>
        </div>
        <div className="certificate">
          <h6>Java Programming</h6>
          <p>University of Helsinki</p>
          <p className="date">Started in 05/10/21</p>
        </div>
        <div className="certificate">
          <h6>
            <a
              rel="noopener noreferrer"
              className="certificateLink"
              target="_blank"
              href="https://drive.google.com/file/d/1XLI6Ko8wfb5FgSsyrTKKUgT6RqjFFUR8/view?usp=sharing"
            >
              The Python Programmer Bootcamp
            </a>
          </h6>
          <p>365 DataScience</p>
          <p className="date">Completed in Apr/13/20</p>
        </div>
        <div className="certificate">
          <h6>
            <a
              rel="noopener noreferrer"
              className="certificateLink"
              target="_blank"
              href="https://drive.google.com/file/d/1QwSH60G2U7eFGqqA_awjoj08kHcKPX5D/view?usp=sharing"
            >
              Git Course
            </a>
          </h6>
          <p>Codecademy</p>
          <p className="date">Completed in Jun/16/2020</p>
        </div>
        <div className="certificate">
          <h6>
            <a
              rel="noopener noreferrer"
              className="certificateLink"
              target="_blank"
              href="https://drive.google.com/file/d/1fzlx5cPJwCrHkhaVjvVxaKXOUFOjc8Lu/view?usp=sharing"
            >
              Building Interactive JavaScript Websites Course
            </a>
          </h6>
          <p>Codecademy</p>
          <p className="date">Completed in Jun/05/2020</p>
        </div>
        <div className="certificate">
          <h6>
            <a
              rel="noopener noreferrer"
              className="certificateLink"
              target="_blank"
              href="https://i.imgur.com/tr1AS7c.png"
            >
              Certified 80+ Words per Minute
            </a>
          </h6>
          <p>Monkeytype</p>
          <p className="date">Completed in Oct/01/2021</p>
        </div>
      </div>
      <h1 className="sectionHeader">
        <span>On-line Classes Completed</span>
      </h1>
      <div className="certificates">
        <div className="certificate">
          <h6>Python for Everybody</h6>
          <p>University of Michigan</p>
          <p className="date">Completed in May/20/20</p>
        </div>
        <div className="certificate">
          <h6>Learn React.js</h6>
          <p>Codecademy</p>
          <p className="date">Completed in Jun/20</p>
        </div>
        <div className="certificate">
          <h6>Python Core Language</h6>
          <p>
            Pluralsight Online Learning Platform <br />
          </p>
          <p className="date">
            Tested Expert in Python with a score of 202 out of 300 <br />
            Verified in Apr/5/20
          </p>
        </div>
        <div className="certificate">
          <h6>CS50</h6>
          <p>Harvard University</p>
          <p className="date">Completed in Apr/20</p>
        </div>
      </div>
    </div>
  );
}

export default Certificates;
